var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"text-container",attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.onInputChange,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }